<template>
    <v-layout row justify-center>
        <v-dialog v-model="deveMostarModalNovaModalidade" persistent max-width="600px">
            <v-card>
                <v-card-title class="primary modal-title">
                    <span class="headline">Nova Modalidade</span>
                </v-card-title>
                <v-card-text>
                    <v-container white grid-list-md>
                        <form>
                            <v-text-field
                                v-model="titulo"
                                v-validate="'required|max:100'"
                                :counter="100"
                                :error-messages="errors.collect('titulo')"
                                label="Título*"
                                data-vv-name="titulo"
                                required
                            ></v-text-field>
                            <v-textarea
                                v-model="descricao"
                                v-validate="'required|max:250'"
                                :counter="250"
                                :error-messages="errors.collect('descricao')"
                                label="Descrição*"
                                data-vv-name="descricao"
                                auto-grow
                                rows="1"
                                required
                            ></v-textarea>
                        </form>
                    </v-container>
                    <small v-show="mostrarInfoCampoObrigatorio"> * indica campo obrigatório</small>
                </v-card-text>
                <v-card-actions class="acoes justify-center">
                    <v-btn color="botao-cancelar-color" outline flat @click="cancelar">Cancelar</v-btn>
                    <v-btn color="primary" depressed @click="salvar">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
export default {
    name: 'ModalNovaModalidade',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['deveMostarModalNovaModalidade'],
    data: () => ({
        dialog: false,
        titulo: '',
        descricao: '',
        mostrarInfoCampoObrigatorio: true,
        dictionary: {
            attributes: {
                titulo: 'Título',
                descricao: 'Descrição'
            },
            custom: {
                titulo: {
                    required: () => 'O campo Título é obrigatório',
                    max: 'O campo Título deve conter no máximo 100 caracteres'
                },
                descricao: {
                    required: () => 'O campo Descrição é obrigatório',
                    max: 'O campo Descrição deve conter no máximo 250 caracteres'
                },
            }
        }
    }),

    mounted () {
        this.$validator.localize('pt-BR', this.dictionary)
    },

    methods: {
        salvar() {
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    const payload = {
                        titulo: this.titulo,
                        descricao: this.descricao
                    }

                    this.$emit('confirmar', payload)
                    this.resetar()
                } else {
                    this.mostrarInfoCampoObrigatorio=false
                }
            })
        },
        cancelar() {
            this.resetar()
            this.$emit('cancelar')
        },
        resetar(){
            this.titulo = ''
            this.descricao = ''
            this.$validator.reset()
            this.mostrarInfoCampoObrigatorio= true
        }
    }
}
</script>

<style scoped lang="stylus">
.acoes
    padding 20px 0 !important

</style>